import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import SideNav from './SideNav/SideNav';
import { withRouter } from 'react-router-dom';

const Layout = ({ children, ...rest }) => {
    return (
        <div className="admin-main">
            <SideNav />
            <Container fluid={true}>{children}</Container>
        </div>
    );
};

class AdminLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }
    render() {
        return (
            <Route
                {...this.props.rest}
                render={(matchProps) => (
                         <Layout>
                            <this.props.component {...matchProps} />
                        </Layout>
                )}
            />
        );
    }
}

function mapStateToProps(state) {
    return { authentication: state.authentication }
}

export default withRouter(connect(mapStateToProps, null)(AdminLayout));


